var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("config-menu"),
      _vm._v(" "),
      _vm.hasAnyRole("ROLE_ADMIN")
        ? _c("div", { staticClass: "col-md-10 pt-3" }, [
            !_vm.edit
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-info btn-sm m-1",
                    on: { click: _vm.onEdit }
                  },
                  [_c("i", { staticClass: "fa fa-edit" }), _vm._v("編集")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "form",
              {
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.submit($event)
                  }
                }
              },
              [
                _c("table", { staticClass: "table table-bordered" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("tbody", [
                    _c("tr", [
                      _c("td", [_vm._v("メール通知")]),
                      _vm._v(" "),
                      _c("td", [
                        !_vm.edit
                          ? _c("span", [_vm._v(_vm._s(_vm.config.emailEnable))])
                          : _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.config.emailEnable,
                                  expression: "config.emailEnable"
                                }
                              ],
                              attrs: { type: "number", min: "0", max: "1" },
                              domProps: { value: _vm.config.emailEnable },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.config,
                                    "emailEnable",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v("0: 送信しない、1: 送信する")])
                    ]),
                    _vm._v(" "),
                    _vm.config.emailEnable == 1
                      ? _c("tr", [
                          _c("td", [
                            _vm._v("勤務表ファイルアップロード時のメール通知")
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            !_vm.edit
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.config.emailTimetableUploadEnable
                                    )
                                  )
                                ])
                              : _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.config.emailTimetableUploadEnable,
                                      expression:
                                        "config.emailTimetableUploadEnable"
                                    }
                                  ],
                                  attrs: { type: "number", min: "0", max: "1" },
                                  domProps: {
                                    value: _vm.config.emailTimetableUploadEnable
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.config,
                                        "emailTimetableUploadEnable",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                          ]),
                          _vm._v(" "),
                          _vm._m(1)
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v("メール送信先")]),
                      _vm._v(" "),
                      _c("td", [
                        !_vm.edit
                          ? _c("span", [_vm._v(_vm._s(_vm.config.emailTo))])
                          : _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.config.emailTo,
                                  expression: "config.emailTo"
                                }
                              ],
                              attrs: { type: "text" },
                              domProps: { value: _vm.config.emailTo },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.config,
                                    "emailTo",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v("カンマ区切りで指定可")])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v("デフォルト労働時間単位")]),
                      _vm._v(" "),
                      _c("td", [
                        !_vm.edit
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.config.defaultWorkTimeInterval))
                            ])
                          : _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.config.defaultWorkTimeInterval,
                                  expression: "config.defaultWorkTimeInterval"
                                }
                              ],
                              attrs: { type: "number", min: "0", max: "60" },
                              domProps: {
                                value: _vm.config.defaultWorkTimeInterval
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.config,
                                    "defaultWorkTimeInterval",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v("例） 0、15、30、60")])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v("デフォルト労働開始日")]),
                      _vm._v(" "),
                      _c("td", [
                        !_vm.edit
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.config.defaultWorkStartDate))
                            ])
                          : _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.config.defaultWorkStartDate,
                                  expression: "config.defaultWorkStartDate"
                                }
                              ],
                              attrs: { type: "number", min: "0", max: "28" },
                              domProps: {
                                value: _vm.config.defaultWorkStartDate
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.config,
                                    "defaultWorkStartDate",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v("例）15日締めの場合、16を設定。デフォルトは1")
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm.edit
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: { type: "button" },
                        on: { click: _vm.onCancel }
                      },
                      [_vm._v("キャンセル")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.edit
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "submit" }
                      },
                      [_vm._v("確定")]
                    )
                  : _vm._e()
              ]
            )
          ])
        : _c("p", [_vm._v("閲覧権限がありません")])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "thead-light" }, [
      _c("tr", [
        _c("th", [_vm._v("名称")]),
        _vm._v(" "),
        _c("th", [_vm._v("設定値")]),
        _vm._v(" "),
        _c("th", [_vm._v("説明")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _vm._v("0: 送信しない、1: 送信する"),
      _c("span", { staticClass: "text-danger" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-49f25669", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49f25669","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/js/components/admin/config/Config.vue
// module id = 392
// module chunks = 0